// extracted by mini-css-extract-plugin
module.exports = {"Notes":"Notes_Notes__XoHqb"};